<template>
  <el-dialog
    title="选择抽奖礼品"
    :visible.sync="addvisible"
    width="80%"
    append-to-body
    @click="closeDialog"
  >
    <div class="innerBody">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        border
        ref="multipleTable"
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column prop="bindId" label="绑定ID" width="80"> </el-table-column>
        <el-table-column prop="id" label="商品ID" width="80"> </el-table-column>
        <el-table-column prop="image" label="商品图片">
          <template slot-scope="scope">
            <img
              :src="$store.state.fileBaseUrl + scope.row.image"
              alt=""
              style="width: 100px; height: 100px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品标题"> </el-table-column>
        <el-table-column prop="pointsPrice" label="兑换积分"> </el-table-column>
        <el-table-column prop="pointsPrice" label="抽奖状态">
            <template slot-scope="scope">
          <div>
            <el-tag type="warning" v-show="!scope.row.hasWinner"
              >待抽奖</el-tag
            >
            <el-tag type="success" v-show="scope.row.hasWinner"
              >已开奖</el-tag
            >
          </div>
        </template>
        </el-table-column>
        <el-table-column prop="winnerName" label="中奖用户"> </el-table-column>
        <el-table-column prop="winnerUserId" label="中奖用户ID"> </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :disabled="scope.row.hasWinner"
              @click="handleEdit(scope.row)"
              >选择中奖用户</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm()">关闭</el-button>
    </div>

    <user ref="userLog" @close="confirm"></user>
  </el-dialog>
</template>

<script>
import user from "./user.vue";
export default {
  data() {
    return {
      loading: false, //是显示加载
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        onSale: "",
      },
      addvisible: false,
      multipleSelection: [],
      currentTask: null,
    };
  },
  components: {
    user,
  },
  methods: {
    handleEdit(item) {
      if (item.bindId == null) {
        this.$message.warning("该奖品缺少绑定ID，请重新保存任务后再开奖");
        return;
      }
      this.$refs.userLog.init(item.bindId, item.id, this.currentTask.id);
    },
    confirm() {
      this.$emit('close')
      this.addvisible = false;
    },
    init(item) {
      this.currentTask = item;
      this.listData = item.prizeGoods;
      this.addvisible = true;
    },
    closeDialog() {
      this.addvisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}
</style>





// WEBPACK FOOTER //
// src/views/tasks/draw.vue